module.exports = __webpack_public_path__ + "static/media/NETFL.73aa6eac.png";